












































































import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import classes from "@/config/wow/classes";

/**
 * Helpers
 */

/**
 * Mixins
 */

/**
 * Components
 */
import Dialog from "@/components/_global/Dialog.vue";

/**
 * API
 */
import charactersAPI from "@/api/characters";
import teamsAPI from "@/api/teams";
import gameAPI from "@/api/game";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetRealmsResponse } from "@/api/game/get-realms.response";
import { SearchCharacterResponse } from "@/api/characters/search-character.response";

/**
 * VueX Modules
 */
const teamModule = namespace("team");


/**
 * Add character in team modal.
 */
@Component
export default class AddCharacterDialog extends Vue {
	$refs!: {
		modal: Dialog;
	};

	/// Injections
	imageLinks = imageLinks;
	classes = classes;

	/// Properties
	@Prop()
	onAfterAdd!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	realms: GetRealmsResponse.Realm[] | null = null;
	characterFound: SearchCharacterResponse | null = null;
	searchDone = false;

	// Form
	name = "";
	realm: string | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/// Methods
	async open() {
		this.name = "";
		this.realm = null;
		this.searchDone = false;
		this.isLoading = true;
		this.$refs.modal.open();
		await this.fetchRealms();
		this.isLoading = false;
	}

	close() {
		this.$refs.modal.close();
	}

	async fetchRealms() {
		this.realms = await gameAPI.fetchRealms(this.currentTeam.guildRegion);
	}

	async handleAddCharacterClick(character: SearchCharacterResponse) {
		this.isLoading = true;
		try {
			await teamsAPI.addCharacter(this.currentTeam.id, character.realm.name, character.name);
			this.name = "";
			this.characterFound = null;
			this.searchDone = false;
			this.$snackbar.openInfo(this.$t("snackbar.success"));
			if (this.onAfterAdd) {
				await this.onAfterAdd();
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	handleRealmChange() {
		this.searchDone = false;
		this.isLoading = true;
		this.searchForCharacter(this);
	}

	handleCharacterNameInput() {
		this.searchDone = false;
		this.isLoading = true;
		this.searchForCharacter(this);
	}

	searchForCharacter = _.debounce(async function (that: AddCharacterDialog) {
		if (!that.name || !that.realm) {
			that.isLoading = false;
			return;
		}
		try {
			const characterFound = await charactersAPI.searchCharacter(that.currentTeam.guildRegion, that.realm, that.name);
			that.characterFound = characterFound;
			that.searchDone = true;
		} catch (err) {
			that.handleAPIError(err);
		}
		that.isLoading = false;
	}, 1000);
}
